import { ReactNode } from 'react';
import { SelectedNodesContext } from '@/features/connect-dots/contexts/SelectedNodesContext';
import { useSelectedFilterItemsImpl } from '@/features/connect-dots/hooks/useSelectedFilterItemsImpl';

export function SelectedNodesProvider({ children }: { children: ReactNode }) {
  const value = useSelectedFilterItemsImpl();
  return (
    <SelectedNodesContext.Provider value={value}>
      {children}
    </SelectedNodesContext.Provider>
  );
}
